export default __webpack_public_path__ + "static/media/element_74.36161b5a.webp";